import { useContext, useState, useEffect } from 'react';

import RingLoader from 'react-spinners/RingLoader';

import { GoodCard } from './GoodCard/GoodCard';
import { GoodsListContext } from '../Context/GoodsListContext';
import { UserContext } from '../../UserContext';

import { ChevronLeft } from '../../../Components/SvgComponents/ChevronLeft';
import { ChevronDoubleLeft } from '../../../Components/SvgComponents/ChevronDoubleLeft';
import { ChevronRight } from '../../../Components/SvgComponents/ChevronRight';
import { ChevronDoubleRight } from '../../../Components/SvgComponents/ChevronDoubleRight';
import { useWindowSize } from '../../../Components/useSizeHook';

export const GoodsList = () => {
  const {
    state: { goodsList, filters, sorting },
    dispatch,
  } = useContext(GoodsListContext);
  const { search } = useContext(UserContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [goodsPerPage, setGoodsPerPage] = useState(6);
  const size = useWindowSize();

  useEffect(() => {
    if (size.width >= 1442) {
      setGoodsPerPage(6);
    } else if (size.width < 1442 && size.width > 942) {
      setGoodsPerPage(4);
    } else if (size.width < 943 && size.width > 768) {
      setGoodsPerPage(2);
    } else {
      setGoodsPerPage(1);
    }
  }, [size.width]);

  const filterGoods = (good, filters) => {
    let result = filters.house === 'All houses' || good.house.includes(filters.house);

    if (!result) return false;

    if (filters.categories.length) {
      result = good.categories.filter((value) => filters.categories.includes(value)).length;
    }

    if (search) {
      result = good.name.trim().toLowerCase().includes(search);
    }

    return result;
  };

  const sortGoods = (value, goodA, goodB) => {
    switch (value) {
      case 'Price ↑':
        return Number(goodA.price) - Number(goodB.price);
      case 'Price ↓':
        return Number(goodB.price) - Number(goodA.price);
      case 'By name, A-Z':
        return goodA.name > goodB.name ? 1 : -1;
      default:
        return goodA.name > goodB.name ? -1 : 1;
    }
  };

  const filteredGoods = goodsList
    .filter((good) => filterGoods(good, filters, search))
    .sort((goodA, goodB) => sortGoods(sorting, goodA, goodB))
    .reduce(
      (accumulator, currentValue) => {
        if (accumulator[accumulator.length - 1].length === goodsPerPage) {
          accumulator.push([]);
        }

        accumulator[accumulator.length - 1].push(currentValue);
        return accumulator;
      },
      [[]]
    );

  const turnNextPage = () => {
    if (currentPage < filteredGoods.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const turnPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const swipeStartPage = () => {
    setCurrentPage(1);
  };

  const swipeEndPage = () => {
    setCurrentPage(filteredGoods.length);
  };

  return (
    <div className="flex flex-col items-center gap-4 smart:gap-10  w-full z-20">
      <h3 className="font-crimson font-normal text-2xl smart:text-3xl md:text-4xl text-center leading-7 tracking-wider">
        Get closer to the Magic
      </h3>
      <div className="flex flex-col justify-between items-center">
        <div className="px-2 smart:px-6 lg:px-10 flex justify-center flex-wrap gap-5 md:gap-7">
          {goodsList.length ? (
            filteredGoods[currentPage - 1].map((good) => <GoodCard key={good.id} data={good} />)
          ) : (
            <RingLoader color={'#091232'} size={120} />
          )}
        </div>
        <div className="mt-10 flex gap-3 md:gap-6 md:mt-24">
          <button
            className={[
              'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-400 hover:border-borderColor hover:text-borderColor',
              currentPage === 1
                ? 'bg-none border-borderColor text-borderColor'
                : 'bg-gradient-to-r from-grStart to-grEnd font-poppins border-transparent text-font',
            ].join(' ')}
            onClick={swipeStartPage}>
            <ChevronDoubleLeft />
          </button>
          <button
            className={[
              'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-400 hover:border-borderColor hover:text-borderColor',
              currentPage === 1
                ? 'bg-none border-borderColor text-borderColor'
                : 'bg-gradient-to-r from-grStart to-grEnd font-poppins border-transparent text-font',
            ].join(' ')}
            onClick={turnPreviousPage}>
            <ChevronLeft />
          </button>
          <div className="p-1 rounded-full h-10 w-10 flex justify-center items-center bg-transparent font-poppins leading-5 border border-borderColor text-background">
            {currentPage}
          </div>
          <button
            className={[
              'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-400 hover:border-borderColor hover:text-borderColor',
              currentPage === filteredGoods.length
                ? 'bg-none border-borderColor text-borderColor'
                : 'bg-gradient-to-r from-grStart to-grEnd font-poppins border-transparent text-font',
            ].join(' ')}
            onClick={turnNextPage}>
            <ChevronRight />
          </button>
          <button
            className={[
              'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-400 hover:border-borderColor hover:text-borderColor',
              currentPage === filteredGoods.length
                ? 'bg-none border-borderColor text-borderColor'
                : 'bg-gradient-to-r from-grStart to-grEnd font-poppins border-transparent text-font',
            ].join(' ')}
            onClick={swipeEndPage}>
            <ChevronDoubleRight />
          </button>
        </div>
      </div>
    </div>
  );
};
